import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home/index.vue";
import Notice from "../views/Notice/index.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  {
    path: "/notice",
    name: "Notice",
    component: Notice,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
